import type { EnumObjectToUnion } from '@/utils/enum';
export const EnvMode = {
  production: 'production',
  staging: 'staging',
  demo: 'demo',
  development: 'development',
  local: 'local'
} as const;
export type EnvMode = EnumObjectToUnion<typeof EnvMode>;
export function createFeatureFlags({
  getSession
}: {
  getSession: () => {
    featureFlags: Record<string, number | string | boolean>;
  } | null;
}) {
  return {
    /**
     * 指定された FeatureFlag が有効かを検証します。
     * v2/session の featureFlags を参照し、キーが存在しない場合は false を返します。
     * 値が boolean でない場合（number, string）は truthiness で判定します。
     *
     * @param key API の featureFlags キー（SNAKE_CASE）
     * @returns FeatureFlag が有効な場合は true、無効な場合は false
     */
    check(key: string): boolean {
      const session = getSession();
      if (!session) {
        return false;
      }
      return Boolean(session.featureFlags[key]);
    }
  };
}
export function getMode(): EnvMode {
  /**
   * 環境モードを取得するロジック
   * @note 型推論が効かないため明示的にtype assertionを行う
   * @see https://ja.vite.dev/guide/env-and-mode#env-variables
   */
  return import.meta.env.MODE as EnvMode;
}